import React from 'react';
import Header from '../components/Header';
import Competitors from '../components/Competitors';
import Footer from '../components/Footer';

function CompetitorsPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <Competitors />
      </div>
      <Footer />
    </>
  );
}

export default CompetitorsPage;
